import { useQuery } from '@tanstack/react-query';
import { getUserStatuses } from '../api/reportsApi';
import { msalInstance } from '@utils';

export const useUserStatuses = () => {
  return useQuery({
    queryKey: ['userStatuses'],
    queryFn: getUserStatuses,
    enabled: msalInstance.getAllAccounts().length > 0,
    staleTime: 5 * 60 * 1000,
  });
};
